import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllTopicApi,
  createTopicApi,
  deleteTopicApi,
  updateTopicApi,
} from "../../apis/curriculumManagement";

export const getAllTopics = createAsyncThunk("topic/getAll", async () => {
  const response = await getAllTopicApi();
  return response.data.data;
});

export const createTopic = createAsyncThunk(
  "topic/create",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createTopicApi(formData);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create topic"
      );
    }
  }
);

export const updateTopic = createAsyncThunk(
  "topic/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await updateTopicApi(id, formData);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update course"
      );
    }
  }
);

export const deleteTopic = createAsyncThunk(
  "topic/delete",
  async (id, { rejectWithValue }) => {
    try {
      await deleteTopicApi(id);
      return id; // Return deleted topic ID to update state
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete topic"
      );
    }
  }
);

const topicSlice = createSlice({
  name: "topics",
  initialState: {
    topics: [],
    status: "idle",
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.topics = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllTopics.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllTopics.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.topics = action.payload;
      })
      .addCase(getAllTopics.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // create topics

      .addCase(createTopic.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createTopic.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.topics.push(action.payload);
      })
      .addCase(createTopic.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to create topic.";
      })

      // delete
      .addCase(deleteTopic.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteTopic.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.topics = state.topics.filter(
          (topicDelete) => topicDelete.id !== action.payload
        );
      })
      .addCase(deleteTopic.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to delete  topic.";
      })

      // update the topic ---
      .addCase(updateTopic.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateTopic.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.topics = state.topics.map((topic) =>
          topic.id === action.payload.id ? action.payload : topic
        ); // Update the course in state
      })
      .addCase(updateTopic.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to update topic.";
      });
  },
});

export default topicSlice.reducer;
